    const roles = [
    {
        path: '/roles',
        name: 'roles.index',
        component: () => import('@/pages/Role/IndexPage.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true,
            layout: 'content',
            title: 'Roles | SKILLS ONLINE ADMIN',
        }
    },
    {
        path: '/roles/create',
        name: 'roles.create',
        component: () => import('@/pages/Role/CreatePage.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true,
            layout: 'content',
            title: 'Create Role | SKILLS ONLINE ADMIN',
        }
    },

    {
        path: '/roles/:id/show',
        name: 'roles.show',
        component: () => import('@/pages/Role/EditPage.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true,
            layout: 'content',
            title: 'Edit Role | SKILLS ONLINE ADMIN',
        }
    },
]

export default roles
